import Chip, { ChipProps } from "@mui/material/Chip";
import Tooltip from "@mui/material/Tooltip";

import { Maybe } from "types";

interface ChipCellProps {
  isOn: boolean;
  indeterminate?: boolean;
  onLabel?: string;
  indeterminateLabel?: string;
  offLabel?: string;
  hide?: boolean;
  tooltip?: Maybe<string>;
}

export const ChipCell = ({
  isOn,
  indeterminate,
  onLabel = "On",
  indeterminateLabel = "Indeterminate",
  offLabel = "Off",
  hide,
  tooltip
}: ChipCellProps) => {
  const chipProps: Pick<ChipProps, "label" | "color"> = {
    label: offLabel,
    color: "default"
  };

  if (hide) {
    return null;
  }

  if (isOn) {
    chipProps.label = onLabel;
    chipProps.color = "success";
  }

  if (indeterminate) {
    chipProps.label = indeterminateLabel;
    chipProps.color = "warning";
  }

  return tooltip ? (
    <Tooltip title={tooltip}>
      <Chip {...chipProps} size="small" />
    </Tooltip>
  ) : (
    <Chip {...chipProps} size="small" />
  );
};
